import React from 'react'
import { IonModal, IonContent } from '@ionic/react'
import './LoadingFullPage.scss'

const LoadingFullPage = () => {
  return(
    <IonModal className="spinner-container-full-page" isOpen={true}>
      <IonContent >
        <div className='spinner-container'>
          <div className="spinner" />
        </div>
      </IonContent>
    </IonModal>
  )
}

export {LoadingFullPage}
